var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import VitalSignCardAPI from './vital-sign-card-api';
import { Card, Text } from '@philips-internal/oswald-ui-components/lib/components';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { eventListener } from '@philips-internal/oswald-ui-core/lib/component/prop-types';
import { TextAlignment } from '@philips-internal/oswald-ui-constants';
import { generateUUID } from '@philips-internal/oswald-ui-utils';
import { ClickEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { SelectionType } from '@philips-internal/oswald-ui-constants';
import { ReactComponent as PendingIcon } from '../../../assets/images/global/time.svg';
import { ReactComponent as ReleasedIcon } from '../../../assets/images/global/check.svg';
import './vital-sign-card.css';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services';
import { isFunction } from '@philips-internal/oswald-ui-utils';
import { DateFormatterUtil, NumericFormatterUtil } from '../../../utils';
let VitalSignCard = class VitalSignCard extends Component {
    constructor() {
        super(...arguments);
        this.handleClick = () => {
            const { nrVitalSign, onClick, vitalSign, vitalSignAttributes } = this.props;
            if (isFunction(onClick)) {
                onClick(new ClickEvent({
                    value: {
                        nrVitalSign,
                        vitalSign,
                        vitalSignAttributes
                    }
                }));
            }
        };
    }
    static { this.propTypes = {
        onClick: eventListener
    }; }
    getStatusIcon() {
        const { vitalSign } = this.props;
        if (vitalSign?.ieStatus && vitalSign.ieStatus.toUpperCase() === 'A') {
            return React.createElement(ReleasedIcon, { className: 'c-clinical-notes-card__color-green' });
        }
        return React.createElement(PendingIcon, { className: 'c-clinical-notes-card__color-orange' });
    }
    renderIndicatorColorStatus() {
        const { vitalSign } = this.props;
        if (vitalSign?.ieStatus && vitalSign.ieStatus.toUpperCase() === 'A') {
            return React.createElement("div", { className: 'c-vital-sign-card__indicator-color-green' });
        }
        return React.createElement("div", { className: 'c-vital-sign-card__indicator-color-orange' });
    }
    getDescription(attribute) {
        const specialAttributes = ['CD_ESCALA_DOR', 'IE_APARELHO_PA', 'IE_MANGUITO', 'IE_MEMBRO', 'IE_SITIO'];
        if (specialAttributes.includes(attribute.nmAttribute)) {
            const domainValue = attribute.vitalSignDomains.find((field) => field.cd == attribute.value);
            const desc = domainValue && domainValue.ds ? domainValue.ds : attribute.value;
            return desc;
        }
        return attribute.value;
    }
    renderIndicator() {
        return (React.createElement("div", { className: 'c-vital-sign-card__indicator' }, this.renderIndicatorColorStatus()));
    }
    renderDefaultData() {
        const { vitalSign } = this.props;
        const localDate = DateFormatterUtil.shortTime(String(vitalSign.dtSinalVital));
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: 'c-vital-sign-card__header' },
                React.createElement("div", { className: 'c-vital-sign-card__hour' },
                    React.createElement(Text, { className: "c-text-hour", value: localDate, alignment: TextAlignment.LEFT, bold: true })),
                React.createElement("div", { className: 'c-vital-sign-card__status' }, this.getStatusIcon())),
            React.createElement("div", { className: "c-component-separator" })));
    }
    getAttribute(attributeName) {
        const { vitalSignAttributes } = this.props;
        const obj = vitalSignAttributes.find(arr => arr.nmAttribute === attributeName);
        return obj;
    }
    isSpecialAttribute(attribute) {
        switch (attribute && attribute.nmAttribute) {
            case 'DS_OBSERVACAO':
            case 'IE_UNID_MED_PESO':
            case 'IE_UNID_MED_ALTURA': return true;
            default: return false;
        }
    }
    isWeightAttribute(attribute) {
        switch (attribute && attribute.nmAttribute) {
            case 'QT_PESO':
            case 'QT_PESO_ATUAL': return true;
            default: return false;
        }
    }
    isHeightAttribute(attribute) {
        switch (attribute && attribute.nmAttribute) {
            case 'QT_ALTURA_M':
            case 'QT_ALTURA_CM': return true;
            default: return false;
        }
    }
    prepareWeigthAttribute(attribute) {
        if (!attribute || !attribute.value)
            return 0;
        const measureUnitAttribute = this.getAttribute('IE_UNID_MED_PESO');
        if (measureUnitAttribute) {
            const nmAttribute = attribute.nmAttribute;
            const cameValueKG = nmAttribute.toUpperCase() === 'QT_PESO' && attribute.value;
            const cameValueG = nmAttribute.toUpperCase() === 'QT_PESO_ATUAL' && attribute.value;
            const weightLabel = MessageService.translate('text.weight');
            let measureUnit = measureUnitAttribute.value;
            if (!measureUnit) {
                measureUnit = 'kg';
            }
            attribute.dsLabel = `${weightLabel} (${measureUnit})`;
            let value = Number(attribute.value);
            switch (measureUnit.toLowerCase()) {
                case 'kg':
                    if (cameValueG) {
                        value = value ? value / 1000 : value;
                    }
                    break;
                case 'g':
                    if (cameValueKG) {
                        value = value ? value * 1000 : value;
                    }
                    break;
                default:
                    break;
            }
            return value;
        }
        return 0;
    }
    prepareHeigthAttribute(attribute) {
        if (!attribute || !attribute.value)
            return 0;
        const measureUnitAttribute = this.getAttribute('IE_UNID_MED_ALTURA');
        if (measureUnitAttribute) {
            const nmAttribute = attribute.nmAttribute;
            const cameValueM = nmAttribute.toUpperCase() === 'QT_ALTURA_M' && attribute.value && attribute.value;
            const cameValueCM = nmAttribute.toUpperCase() === 'QT_ALTURA_CM' && attribute.value && attribute.value;
            const heightLabel = MessageService.translate('text.height');
            let measureUnit = measureUnitAttribute.value;
            if (!measureUnit) {
                measureUnit = 'm';
            }
            attribute.dsLabel = `${heightLabel} (${measureUnit})`;
            let value = Number(attribute.value);
            switch (measureUnit.toLowerCase()) {
                case 'm':
                    if (cameValueCM) {
                        value = value ? value / 100 : value;
                    }
                    break;
                case 'cm':
                    if (cameValueM) {
                        value = value ? value * 100 : value;
                    }
                    break;
                default:
                    break;
            }
            return value;
        }
        return 0;
    }
    getDimensionValue(attribute) {
        if (this.isWeightAttribute(attribute))
            return this.prepareWeigthAttribute(attribute);
        if (this.isHeightAttribute(attribute))
            return this.prepareHeigthAttribute(attribute);
        return null;
    }
    buildLimitElement(outLimit, index) {
        if (!outLimit)
            return null;
        const attentionMessage = MessageService.translate('text.message-alert-attention');
        if (outLimit === 'S') {
            return (React.createElement("div", { className: "c-vital-sign-token", key: `limit-${index}-S` },
                React.createElement(Text, { className: "c-text-value", value: attentionMessage, alignment: TextAlignment.LEFT })));
        }
        if (outLimit === 'N') {
            return (React.createElement("div", { className: "c-vital-sign-token-without-value", key: `limit-${index}-N` },
                React.createElement(Text, { className: "c-text-value", alignment: TextAlignment.LEFT })));
        }
        return null;
    }
    computeDisplayValue(attribute, dimensionValue, rawValue) {
        const name = attribute.nmAttribute;
        if (dimensionValue !== null && (name === 'QT_ALTURA_M' || name === 'QT_PESO')) {
            return dimensionValue;
        }
        return rawValue;
    }
    buildVitalSignItem(attribute, index, isBold) {
        let rawValue = this.getDescription(attribute);
        if (rawValue === undefined)
            return null;
        if (attribute.dsType === 'DATE' && rawValue) {
            rawValue = DateFormatterUtil.short(String(rawValue));
        }
        const dimensionValue = this.getDimensionValue(attribute);
        const displayValue = this.computeDisplayValue(attribute, dimensionValue, rawValue);
        const formatted = NumericFormatterUtil.formatDecimalValue(displayValue);
        const limitElement = this.buildLimitElement(attribute.outLimit, index);
        const label = attribute.dsLabel?.trim();
        return (React.createElement("div", { className: 'c-vital-sign-card-content-item', key: `item-${index}` },
            React.createElement("div", { className: 'c-vital-sign-card-content-label' },
                React.createElement(Text, { className: "c-text-label", value: label, bold: isBold })),
            React.createElement("div", { className: 'c-vital-sign-card-content-value' },
                React.createElement(Text, { className: "c-text-value", value: formatted, bold: isBold })),
            React.createElement("div", { className: 'c-vital-sign-card-content-limit' }, limitElement)));
    }
    renderDynamicData() {
        const { vitalSignAttributes } = this.props;
        if (!vitalSignAttributes || vitalSignAttributes.length === 0) {
            return React.createElement("div", { className: 'c-vital-sign-card__dynamic-data' });
        }
        let count = 0;
        const vitalSignItems = [];
        for (let i = 0; i < vitalSignAttributes.length; i++) {
            const attribute = vitalSignAttributes[i];
            if (this.isSpecialAttribute(attribute))
                continue;
            count += 1;
            const element = this.buildVitalSignItem(attribute, i, count % 2 === 0);
            if (element)
                vitalSignItems.push(element);
        }
        return (React.createElement("div", { className: 'c-vital-sign-card__dynamic-data' }, vitalSignItems));
    }
    render() {
        const legends = [
            {
                color: 'signal-green-60',
                icon: React.createElement(ReleasedIcon, null),
                label: MessageService.translate('text.finished'),
                value: MessageService.translate('text.finished')
            },
            {
                color: 'signal-orange-45',
                icon: React.createElement(PendingIcon, null),
                label: MessageService.translate('tws.label-pending'),
                value: MessageService.translate('tws.label-pending')
            }
        ];
        const { nrVitalSign } = this.props;
        return (React.createElement(Card, { className: 'c-vital-sign-card', onClick: this.handleClick, superscription: legends, selectionType: SelectionType.SINGLE, width: 12, key: nrVitalSign, uuid: generateUUID() },
            this.renderIndicator(),
            React.createElement("div", { className: 'c-vital-sign-card__wrapper' },
                this.renderDefaultData(),
                this.renderDynamicData())));
    }
};
VitalSignCard = __decorate([
    AwesomeComponent({ api: VitalSignCardAPI, type: ComponentType.DATA_DISPLAY })
], VitalSignCard);
export default VitalSignCard;
//# sourceMappingURL=vital-sign-card.js.map